
import request from '@/axios/index.js'
const uri = "/reg/";
// 注册
export function checkRegister(data) {
    return request.axios({
        url: uri+'checkRegister',
        data: data
    })
}
// 获取邀请码
export function getInviteCode(data,loading) {
    return request.axios({
        url: uri+'getInviteCode',
        data: data,
        loading:loading
    })
}
// 保存注册信息
export function saveUserInf(data,loading) {
    return request.axios({
        url: uri+'saveUserInf',
        data: data,
        loading:loading
    })
}
export function getCaptcha(data,loading) {
    return request.axios({
        url: '/captcha',
        data: data,
        loading:loading
    })
}

export function savePersonInf(data,loading) {
    return request.axios({
        url: '/reg/savePersonInf',
        data: data,
        loading:loading
    })
}





// WEBPACK FOOTER //
// ./src/api/register.js